var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-mobile d-flex justify-content-end",class:_vm.headerClasses,attrs:{"id":"kt_header_mobile"}},[_c('div',{staticClass:"d-flex align-items-end"},[(_vm.asideEnabled)?_c('button',{staticClass:"btn p-0 burger-icon burger-icon-left",attrs:{"id":"kt_aside_mobile_toggle"}},[_c('span')]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }